import RoundedButton from 'components/Common/MasterComponents/Buttons/RoundedButton'
import { FC } from 'react'

interface CloseButtonProps {
  onClick: () => void
}

const CloseButton: FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <RoundedButton onClick={onClick} type='secondary' size='M'>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12.6266 1.95964C13.0172 1.56928 13.6502 1.56917 14.0407 1.95964C14.4306 2.35016 14.4309 2.98335 14.0407 3.3737L9.41374 7.99968L14.0407 12.6266L14.1091 12.7018C14.4292 13.0946 14.4067 13.6746 14.0407 14.0407C13.6746 14.4067 13.0946 14.4292 12.7018 14.1091L12.6266 14.0407L7.99968 9.41374L3.3737 14.0407C2.98335 14.4309 2.35016 14.4306 1.95964 14.0407C1.56917 13.6502 1.56928 13.0172 1.95964 12.6266L6.58562 7.99968L1.95964 3.3737C1.56912 2.98318 1.56912 2.35017 1.95964 1.95964C2.35017 1.56912 2.98318 1.56912 3.3737 1.95964L7.99968 6.58562L12.6266 1.95964Z'
          fill='#717284'
        />
      </svg>
    </RoundedButton>
  )
}

export default CloseButton
